export const orderReturnsQueryKey = (orderId: string) => [
  "orderReturns",
  orderId,
];
